var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 64,
    viewBox: "0 0 86 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2067_10116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.50023,
    y: 8.50023,
    width: 69.0312,
    height: 47.0212,
    rx: 5.50248,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.00045
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5161 42.3307C41.1319 44.3882 38.0391 45.6303 34.6596 45.6303C27.1188 45.6303 21.0059 39.4463 21.0059 31.8181C21.0059 24.1898 27.1188 18.0059 34.6596 18.0059C38.0391 18.0059 41.1319 19.248 43.5161 21.3055C45.9003 19.248 48.9931 18.0059 52.3726 18.0059C59.9134 18.0059 66.0263 24.1898 66.0263 31.8181C66.0263 39.4463 59.9134 45.6303 52.3726 45.6303C48.9931 45.6303 45.9003 44.3882 43.5161 42.3307Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5166 42.3307C46.4523 39.7972 48.3138 36.0276 48.3138 31.8181C48.3138 27.6086 46.4523 23.8389 43.5166 21.3055C45.9008 19.248 48.9936 18.0059 52.3731 18.0059C59.9139 18.0059 66.0268 24.1898 66.0268 31.8181C66.0268 39.4463 59.9139 45.6303 52.3731 45.6303C48.9936 45.6303 45.9008 44.3882 43.5166 42.3307Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5162 42.3299C46.4518 39.7964 48.3133 36.0268 48.3133 31.8173C48.3133 27.6078 46.4518 23.8381 43.5162 21.3047C40.5805 23.8381 38.719 27.6078 38.719 31.8173C38.719 36.0268 40.5805 39.7964 43.5162 42.3299Z",
    fill: "#FF5E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2067_10116",
    x: 0.437531,
    y: 0.437531,
    width: 85.1564,
    height: 63.1464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78123
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2067_10116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2067_10116",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.615242761eef04a0570fe91761a1a4b3.svg";
export { ForwardRef as ReactComponent };